<input nz-input #input *ngIf="dataset[row] !== undefined && dataset[row][colData.Name] !== undefined"
  [disabled]="GetDisabledValue()" [name]="colData.Name" [(ngModel)]="dataset[row][colData.Name]"
  [ngModelOptions]="{ updateOn: 'blur'}" (ngModelChange)="valueChanged($event);" />
